import { render, staticRenderFns } from "./CreateResearch.vue?vue&type=template&id=a5ec0c90&"
import script from "./CreateResearch.vue?vue&type=script&lang=js&"
export * from "./CreateResearch.vue?vue&type=script&lang=js&"
import style0 from "./CreateResearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports